import { render, staticRenderFns } from "./SvgUser.vue?vue&type=template&id=390dab6f&scoped=true&"
import script from "./SvgUser.vue?vue&type=script&lang=js&"
export * from "./SvgUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390dab6f",
  null
  
)

export default component.exports